/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      slickTestimonials();

      $( window ).on( 'resize', function() {
        slickTestimonials();
      } );

      function slickTestimonials() {
        $( '.testimonials-slider' ).each( function() {
          $( this ).find( '.slider' ).slick( {
            dots: false,
            arrows: true,
            prevArrow: $( this ).find( '.prev-slide' )[0],
            nextArrow: $( this ).find( '.next-slide' )[0],
            slidesToShow: 1,
            fade: true,
            cssEase: 'linear',
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
